import type { inferRouterInputs, inferRouterOutputs } from '@trpc/server'
import type { AppRouter } from '@tandem/api/src/routers'
import { RefObject } from 'react'
import { createTRPCClient, httpBatchLink, httpLink, splitLink, isNonJsonSerializable, TRPCClientError } from '@trpc/client'
import { createTRPCContext } from '@trpc/tanstack-react-query'
import { MutationCache, QueryCache, QueryClient } from '@tanstack/react-query'
import { zodErrorLink } from '@tandem/ui/trpc/errors'
import { useToast } from '@tandem/ui/Toast'


export const { TRPCProvider, useTRPC, useTRPCClient } = createTRPCContext<AppRouter>()

export type RouterInputs = inferRouterInputs<AppRouter>;
export type RouterOutputs = inferRouterOutputs<AppRouter>


let queryClient: QueryClient

export function getQueryClient(toastRef: RefObject<ReturnType<typeof useToast>>) {
  if (!queryClient || typeof window === 'undefined') {
    let handleError = (error: Error) => {
      if (!(error instanceof TRPCClientError)) return

      console.log({ error })
      if (error.data?.httpStatus === 401 || error.data?.code === 'UNAUTHORIZED') {
        return
      } else if (error.data?.httpStatus === 500 || error.data?.code === 'INTERNAL_SERVER_ERROR') {
        toastRef.current('Ошибка сервера. Мы уже разбираемся. Попробуйте повторить позже.')
      } else if (error.data?.code === 'BAD_REQUEST' && error.message) {
        try {
          JSON.parse(error.message)
        } catch {
          toastRef.current(error.message)
        }
      } else if (error.message === 'Load failed') {
        toastRef.current('Отсутствует соединение с сервером.')
      } else {
        toastRef.current('Неизвестная ошибка. Попробуйте позже.')
      }
    }

    console.log('create queryclient')
    queryClient = new QueryClient({
      queryCache: new QueryCache({ onError: handleError }),
      mutationCache: new MutationCache({ onError: handleError }),
      defaultOptions: {
        queries: {
          staleTime: 1_000 * 60 * 5,
          retry: 1,
          experimental_prefetchInRender: true,
        },
      },
    })
  }

  return queryClient!
}


export let activeCompany = { id: null as number | null }

let headers = () => activeCompany.id != null ? { 'x-company-id': String(activeCompany.id) } : {}

export let trpcClient = createTRPCClient<AppRouter>({
  links: [
    zodErrorLink(),
    splitLink({
      condition: (op) => isNonJsonSerializable(op.input),
      true: httpLink({
        url: env.API_URL,
        headers,
        fetch: (url, options) => fetch(url, { ...options, credentials: 'include' }),
      }),
      false: httpBatchLink({
        url: env.API_URL,
        headers,
        fetch: (url, options) => fetch(url, { ...options, credentials: 'include' }),
      }),
    }),
  ],
})
